module.exports = __webpack_public_path__ + "img/27.19916654.jpg";